import Vue from "vue";
import Router from "vue-router";
import BranchEdit from "./views/branches/BranchEdit.vue";
import Branches from "./views/branches/Branches.vue";
import UserBranches from "./views/branches/UserBranches.vue";
import Companies from "./views/companies/Companies.vue";
import CompanyEdit from "./views/companies/CompanyEdit.vue";
import CompanyPriority from "./views/companies/CompanyPriority.vue";
import PresentationSettings from "./views/companies/settings/PresentationSettings.vue";
import PaymentSettings from "./views/companies/settings/PaymentSettings.vue";
import ResetPassword from "./views/ResetPassword.vue";
import Login from "./views/Login.vue";
import UserEdit from "./views/users/UserEdit.vue";
import Users from "./views/users/Users.vue";
import ImageClassification from "./views/inventory/ImageClassification";
import TrainingSetImageClassification from "./views/superAdmin/TrainingSetImageClassification.vue";
import RecommenderAnalysis from "./views/superAdmin/RecommenderAnalysis.vue";
import StatsBuilder from "./views/superAdmin/StatsBuilder.vue";
import CatalogEdit from "./views/inventory/catalogs/CatalogEdit.vue";
import Catalogs from "./views/inventory/catalogs/Catalogs.vue";
import companyCatalogs from "./views/inventory/catalogs/CompanyCatalogs.vue";
import CategoryEdit from "./views/inventory/categories/CategoryEdit.vue";
import Categories from "./views/inventory/categories/Categories.vue";
import ChoiceEdit from "./views/inventory/choices/ChoiceEdit.vue";
import Choices from "./views/inventory/choices/Choices.vue";
import ChoiceItemEdit from "./views/inventory/choices/ChoiceItemEdit.vue";
import ChoiceItems from "./views/inventory/choices/ChoiceItems.vue";
import ChoiceGroupEdit from "./views/inventory/choices/ChoiceGroupEdit.vue";
import ChoiceItemPriority from "./views/inventory/choices/ChoiceItemPriority";
import ChoicePriority from "./views/inventory/choices/ChoicePriority";
import ChoiceGroups from "./views/inventory/choices/ChoiceGroups.vue";
import ItemEdit from "./views/inventory/items/ItemEdit.vue";
import Items from "./views/inventory/items/Items.vue";
import Conditions from "./views/inventory/conditions/Conditions.vue";
import ConditionEdit from "./views/inventory/conditions/ConditionEdit.vue";
import Modifiers from "./views/inventory/modifiers/Modifiers.vue";
import ModifierEdit from "./views/inventory/modifiers/ModifierEdit.vue";
import ModifierGroups from "./views/inventory/modifiers/ModifierGroups.vue";
import ModifierGroupEdit from "./views/inventory/modifiers/ModifierGroupEdit.vue";
import ModifierPriority from "./views/inventory/modifiers/ModifierPriority"
import Promotions from "./views/inventory/promotions/Promotions";
import PromotionEditLegacy from "./views/inventory/promotions/PromotionEditLegacy";
import PromotionModal from "./views/inventory/promotions/PromotionModal";
import PromotionUsage from "./views/inventory/promotions/PromotionUsage";
import Tags from "./views/inventory/tags/Tags";
import TagEdit from "./views/inventory/tags/TagEdit";
import Inventory from "./views/inventory/Inventory.vue";
import Upsell from "./views/inventory/Upsell.vue";
import SettingsOnlineOrdering from "./views/settings/onlineOrdering/SettingsServices.vue";
import SettingsKiosk from "./views/settings/kiosk/SettingsServices.vue";
import SettingsMenuBoard from "./views/settings/menuBoard/SettingsMenuBoard.vue";
import SettingsMobileApp from "./views/settings/mobileApp/SettingsMobileApp.vue";
import SettingsExternalPos from "./views/settings/externalPos/SettingsExternalPos.vue";
import SettingsQRPayment from "./views/settings/QRPayment.vue";
import SettingsTunnel from "./views/settings/externalPos/SettingsTunnel.vue";
import SettingsTimesheet from "./views/settings/SettingsTimesheet.vue";
import ExternalPosSynchronisation from "@/views/settings/externalPos/ExternalPosSynchronisation";
import CheckExternalConnection from "./views/settings/externalPos/CheckExternalConnection.vue";
import SettingsShipper from "./views/settings/shipper/SettingsShipper.vue";
import MaitreDSync from "./views/settings/externalPos/MaitreDSync.vue";
import SettingsEmail from "./views/settings/SettingsEmail.vue";
import OnlineOrderingStyle from "./views/display/OnlineOrderingStyle.vue";
import KioskStyle from "./views/display/KioskStyle.vue";
import CateringDeliveries from "./views/catering/CateringDeliveries.vue";
import CateringSales from "./views/catering/CateringSales.vue";
import CateringPrep from "./views/catering/CateringPrep.vue";
import Sales from "./views/sales/Sales.vue";
import POSSales from "./views/sales/POSSales.vue";
import POSSale from "./views/sales/POSSale.vue";
import POSInvoices from "./views/sales/POSInvoices.vue";
import POSInvoice from "./views/sales/POSInvoice.vue";
import Sale from "./views/sales/Sale.vue";
import TableSales from "./views/sales/TableSales.vue";
import Customers from "./views/sales/Customers.vue";
import Customer from "./views/sales/Customer.vue";
import CustomerReport from "./views/stats/CustomerReport.vue";
import Supplements from "./views/inventory/supplements/Supplements";
import SupplementEdit from "./views/inventory/supplements/SupplementEdit";
import FailedSales from "./views/superAdmin/FailedSales";
import TestSales from "@/views/superAdmin/TestSales";
import StatisticsBranch from "./views/stats/StatisticsBranch";
import StatisticsCompany from "./views/stats/StatisticsCompany.vue";
import SaleReport from "./views/stats/SaleReport";
import CloneInventory from "./views/superAdmin/CloneInventory.vue";
import MoveCompany from "./views/superAdmin/MoveCompany.vue";
import LoyaltyConfig from "./views/loyalty/config/LoyaltyConfig.vue";
import ModifierGroupPriority from "./views/inventory/modifiers/ModifierGroupPriority"
import UnderConstruction from "./views/UnderConstruction.vue";
import SalesStatus from "./views/superAdmin/SalesStatus"
import LoyaltyTransactions from "./views/loyalty/Transactions.vue";
import LoyaltyTransaction from "./views/loyalty/Transaction.vue";
import LoyaltyAccounts from "./views/loyalty/LoyaltyAccounts.vue";
import LoyaltyAccount from "./views/loyalty/LoyaltyAccount.vue";
import LoyaltyTransactionStat from "./views/loyalty/LoyaltyTransactionStat.vue";
import Tax from "./views/superAdmin/Tax.vue";
import Taxes from "./views/superAdmin/Taxes.vue";
import TaxGroup from "./views/superAdmin/TaxGroup.vue";
import TaxGroups from "./views/superAdmin/TaxGroups.vue";
import AdminCommands from "./views/superAdmin/AdminCommands";
import AppVersion from "@/views/superAdmin/AppVersion";
import ServerStatus from "@/views/superAdmin/ServerStatus";
import InventoryPowerUser from "./views/superAdmin/InventoryPowerUser";
import Newsletter from "./views/export/Newsletter";
import POS from "./views/pos/POS";
import POSKitchenDisplaySystem from "./views/pos/KitchenDisplaySystem";
import DispatchCustomers from "./views/sales/DispatchCustomers.vue";
import DispatchCustomer from "./views/sales/DispatchCustomer.vue";
import Translations from "./views/display/Translations.vue";
import Heartbeat from "./views/superAdmin/Heartbeat";
import TunnelMigration from "./views/superAdmin/TunnelMigration";
import ThirdPartyDelivery from "./views/settings/onlineOrdering/ThirdPartyDelivery";
import QuickConfig from "./views/settings/quick/QuickConfig";
import CompanyChangeLog from "./views/superAdmin/CompanyChangeLog";
import Reception from "./views/reception/Reception.vue";
import RolePermissions from "@/views/permission/RolePermissions";
import BranchPayment from "@/views/branches/BranchPayment";
import FileImport from "@/views/branches/FileImport";
import CompanyServices from "@/views/companies/Services.vue";
import BranchServices from "@/views/branches/Services.vue";
import BranchInventories from "@/views/branches/BranchInventories.vue";
import PaidFeatures from "@/views/companies/PaidFeatures.vue";
import SmsReport from "@/views/superAdmin/SmsReport.vue";
import StatsPayment from "@/views/superAdmin/StatsPayment";
import SlideSettings from "@/views/superAdmin/SlideSettings";
import Training from "./views/training/Training";
import CreateTestSale from "@/views/sales/CreateTestSale";
import InventoryOutOfStockReport from "./views/stats/InventoryOutOfStockReport";
import OrderRequirements from "./views/inventory/OrderRequirements";
import MediaManager from "./views/branches/MediaManager";
import Brandings from "./views/inventory/brandings/Brandings";
import BrandingEdit from "./views/inventory/brandings/BrandingEdit";
import BrandingCategories from "./views/inventory/brandings/BrandingCategories";
import GiftCards from "./views/loyalty/giftCard/GiftCards";
import GiftCard from "./views/loyalty/giftCard/GiftCard";
import GiftCardReports from "@/views/loyalty/giftCard/GiftCardReports";
import AimsTickets from "./views/inventory/custom/aims/Tickets";
import AimsTicketEdit from "./views/inventory/custom/aims/TicketEdit";
import ApiKeys from "./views/users/ApiKeys";
import QrPaymentRequests from "./views/settings/externalPos/qrPaymentRequest/QrPaymentRequests";
import QrPaymentRequest from "./views/settings/externalPos/qrPaymentRequest/QrPaymentRequest";
import CustomReportQrCodeSales from "@/views/stats/CustomReportQrCodeSales";
import AnomalyReports from "@/views/superAdmin/AnomalyReports";
import ComponentTestQSR from "@/views/test/ComponentTestQSR";
import ReceiptConfiguration from "@/views/printer/ReceiptConfiguration";
import PrinterGroups from "@/views/printer/PrinterGroups";
import PrinterGroupEdit from "@/views/printer/PrinterGroupEdit";
import Printers from "@/views/printer/Printers";
import Licenses from "@/views/pos/Licenses";
import Employees from "./views/employees/Employees";
import EmployeeEdit from "./views/employees/EmployeeEdit";
import PromotionEdit from "./views/inventory/promotions/PromotionEdit";
import PromotionNew from "./views/inventory/promotions/PromotionNew";
import PunchReport from "@/views/employees/PunchReport";
import CatalogsHub from "@/views/hub/CatalogsHub";
import MenuConfigurationHub from "@/views/hub/MenuConfigurationHub";
import MenuHub from "@/views/hub/MenuHub";
import MenuModifiersHub from "./views/hub/MenuModifiersHub";
import BranchUserHub from "./views/hub/BranchUserHub";
import CompanyUserHub from "./views/hub/CompanyUserHub";
import BranchMarketingHub from "./views/hub/BranchMarketingHub";
import AdminUsersHub from "./views/hub/AdminUsersHub";
import LowLevelHub from "./views/hub/LowLevelHub";
import TaxesHub from "./views/hub/TaxesHub";
import MonitoringToolsHub from "./views/hub/MonitoringToolsHub";
import GlobalSupportDebugHub from "./views/hub/GlobalSupportDebugHub";
import GlobalReportsHub from "./views/hub/GlobalReportsHub";
import BranchSuperAdminHub from "./views/hub/BranchSuperAdminHub";
import BranchGlobalSettingsHub from "./views/hub/BranchGlobalSettingsHub";
import VisualConfigurationsHub from "./views/hub/VisualConfigurationsHub";
import BranchCustomersHub from "./views/hub/BranchCustomersHub";
import LoyaltyHub from "./views/hub/LoyaltyHub";
import SaleHub from "./views/hub/SaleHub";
import CateringHub from "./views/hub/CateringHub";
import CompanySuperAdminHub from "./views/hub/CompanySuperAdminHub";
import ExternalPosHub from "./views/hub/ExternalPosHub";
import CompanyGlobalSettingsHub from "./views/hub/CompanyGlobalSettingsHub";
import CompanySupportHub from "./views/hub/CompanySupportHub";
import PosConfigurationHub from "./views/hub/PosConfigurationHub";
import PosPrinterHub from "./views/hub/PosPrinterHub";
import MarketingHub from "./views/hub/MarketingHub";
import PromotionHub from "./views/hub/PromotionHub";
import KioskHub from "./views/hub/KioskHub";
import HelpSupportHub from "./views/hub/HelpSupportHub";
import PosHelpSupportHub from "./views/hub/PosHelpSupportHub";
import ReleaseNotes from "./views/stats/ReleaseNotes";
import Roles from "./views/roles/Roles";
import RoleEdit from "./views/roles/RoleEdit";
import OrderOptions from "./views/pos/OrderOptions";
import ScheduledShutdown from "./views/branches/ScheduledShutdown";
import RevenueCenters from "./views/inventory/revenueCenters/RevenueCenters";
import RevenueCenterEdit from "./views/inventory/revenueCenters/RevenueCenterEdit";
import VisualConfig from "./views/pos/VisualConfig";
import TipManagement from "./views/pos/TipManagement";
import CashDrawerManagement from "./views/pos/CashDrawerManagement";
import PriceAdjustments from "./views/pos/PriceAdjustments";
import Refunds from "./views/pos/Refunds";
import Voids from "./views/pos/Voids";
import BatchReadings from "@/views/pos/BatchReadings.vue";
import BatchReading from "@/components/pos/BatchReading.vue";
import UberEats from "@/views/settings/externalPlatform/UberEats.vue";
import StagingDashboard from "@/views/inventory/staging/StagingDashboard";
import MevConfig from "./views/pos/MevConfig";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      redirect: "/login"
    }, {
      path: "/login",
      name: "login",
      component: Login
    }, {
      path: "/reset_password",
      name: "resetpassword",
      component: ResetPassword
    }, {
      path: "/branches",
      name: "branches",
      component: Branches
    }, {
      path: "/user-branches",
      name: "userBranches",
      component: UserBranches
    }, {
      path: "/branch/edit",
      name: "branchEdit",
      component: BranchEdit
    }, {
      path: "/branch/new",
      name: "branchNew",
      component: BranchEdit
    }, {
      path: "/branch/services",
      name: "BranchServices",
      component: BranchServices
    }, {
      path: "/branch/inventories",
      name: "BranchInventories",
      component: BranchInventories
    }, {
      path: "/companies",
      name: "companies",
      component: Companies
    }, {
      path: "/company/edit",
      name: "companyEdit",
      component: CompanyEdit
    }, {
      path: "/company/new",
      name: "companyNew",
      component: CompanyEdit
    }, {
      path: "/company/services",
      name: "CompanyServices",
      component: CompanyServices
    }, {
      path: "/branch/company-priority",
      name: "companyPriority",
      component: CompanyPriority
    }, {
      path: "/settings/presentation",
      name: "presentationSettings",
      component: PresentationSettings
    }, {
      path: "/settings/payment",
      name: "payment",
      component: PaymentSettings
    }, {
      path: "/promotions",
      name: "promotions",
      component: Promotions
    }, {
      path: "/promotions/legacy-edit",
      name: "promotionEditLegacy",
      component: PromotionEditLegacy
    }, {
      path: "/promotions/new", //TODO should be deleted and replaced by route below
      name: "promotionNewLegacy",
      component: PromotionEditLegacy
    }, {
      path: "/promotions/new-v2",
      name: "promotionNew",
      component: PromotionNew
    }, {
      path: "/promotions/edit",
      name: "promotionEdit",
      component: PromotionEdit
    }, {
      path: "/promotion-modal",
      name: "promotionModal",
      component: PromotionModal
    }, {
      path: "/promotions/usage",
      name: "promotionUsage",
      component: PromotionUsage
    }, {
      path: "/inventory_hours",
      name: "condition",
      component: Conditions
    }, {
      path: "/inventory_hours/edit",
      name: "conditionEdit",
      component: ConditionEdit
    }, {
      path: "/tags",
      name: "tags",
      component: Tags
    }, {
      path: "/tags/edit",
      name: "tagEdit",
      component: TagEdit
    }, {
      path: "/items",
      name: "items",
      component: Items
    }, {
      path: "/item/edit",
      name: "itemEdit",
      component: ItemEdit
    }, {
      path: "/item/new",
      name: "itemNew",
      component: ItemEdit
    }, {
      path: "/brandings",
      name: "brandings",
      component: Brandings
    }, {
      path: "/branding/edit",
      name: "brandingEdit",
      component: BrandingEdit
    }, {
      path: "/branding/new",
      name: "brandingNew",
      component: BrandingEdit
    }, {
      path: "/branding/categories",
      name: "brandingCategories",
      component: BrandingCategories
    }, {
      path: "/categories",
      name: "categories",
      component: Categories
    }, {
      path: "/category/edit",
      name: "categoryEdit",
      component: CategoryEdit
    }, {
      path: "/category/new",
      name: "categoryNew",
      component: CategoryEdit
    }, {
      path: "/catalogs",
      name: "catalogs",
      component: Catalogs
    }, {
      path: "/catalog/edit",
      name: "catalogEdit",
      component: CatalogEdit
    }, {
      path: "/catalog/company-catalogs",
      name: "CompanyCatalogs",
      component: companyCatalogs
    }, {
      path: "/catalog/hub",
      name: "CatalogsHub",
      component: CatalogsHub
    }, {
      path: "/menu/hub",
      name: "MenuHub",
      component: MenuHub
    }, {
      path: "/menu/configuration-hub",
      name: "menuConfigurationHub",
      component: MenuConfigurationHub
    }, {
      path: "/menu/modifiers-hub",
      name: "menuModifiersHub",
      component: MenuModifiersHub
    }, {
      path: "/branch/user-hub",
      name: "branchUserHub",
      component: BranchUserHub
    }, {
      path: "/branch/marketing-hub",
      name: "branchMarketingHub",
      component: BranchMarketingHub
    }, {
      path: "/company/user-hub",
      name: "companyUserHub",
      component: CompanyUserHub
    }, {
      path: "/modifiers",
      name: "modifiers",
      component: Modifiers
  }, {
      path: "/modifiers/edit",
      name: "modifierEdit",
      component: ModifierEdit
    }, {
      path: "/modifiers/priority",
      name: "modifierPriority",
      component: ModifierPriority
    }, {
      path: "/modifier-groups/priority",
      name: "modifierGroupPriority",
      component: ModifierGroupPriority
    },
    {
      path: "/modifier-groups",
      name: "modifierGroups",
      component: ModifierGroups
    }, {
      path: "/modifier-groups/edit",
      name: "modifierGroupEdit",
      component: ModifierGroupEdit
    }, {
      path: "/supplements",
      name: "supplements",
      component: Supplements
    }, {
      path: "/supplement/edit",
      name: "supplementEdit",
      component: SupplementEdit
    }, {
      path: "/supplement/new",
      name: "supplementNew",
      component: SupplementEdit
    }, {
      path: "/choices",
      name: "choices",
      component: Choices
    }, {
      path: "/choice-groups",
      name: "choiceGroups",
      component: ChoiceGroups
    }, {
      path: "/choice-items",
      name: "choiceItems",
      component: ChoiceItems
    }, {
      path: "/choice-items/priority",
      name: "choiceItemPriority",
      component: ChoiceItemPriority
    }, {
      path: "/choice/priority",
      name: "choicePriority",
      component: ChoicePriority
    }, {
      path: "/choices/edit",
      name: "choiceEdit",
      component: ChoiceEdit
    }, {
      path: "/choice-groups/edit",
      name: "choiceGroupEdit",
      component: ChoiceGroupEdit
    }, {
      path: "/choice-items/edit",
      name: "choiceItemEdit",
      component: ChoiceItemEdit

    }, {
      path: "/admin-users-hub",
      name: "adminUsersHub",
      component: AdminUsersHub
    },{
      path: "/users/:role",
      name: "usersByRole",
      component: Users
    }, {
      path: "/user/edit",
      name: "userEdit",
      component: UserEdit
    }, {
      path: "/user/new",
      name: "userNew",
      component: UserEdit
    }, {
      path: "/image-classification",
      name: "imageClassification",
      component: ImageClassification
    }, {
      path: "/training-image-classification",
      name: "trainingImageClassification",
      component: TrainingSetImageClassification
    }, {
      path: "/recommender-analysis",
      name: "recommenderAnalysis",
      component: RecommenderAnalysis
    }, {
      path: "/stats-builder",
      name: "statsBuilder",
      component: StatsBuilder
    }, {
      path: "/failed-sales",
      name: "failedSale",
      component: FailedSales
    }, {
      path: "/test-sales",
      name: "TestSales",
      component: TestSales
    }, {
      path: "/sales-status",
      name: "salesStatus",
      component: SalesStatus
    }, {
      path: "/settings/services/online-ordering",
      name: "settingsOnlineOrdering",
      component: SettingsOnlineOrdering
    }, {
      path: "/settings/services/kiosk",
      name: "settingsKiosk",
      component: SettingsKiosk
    }, {
      path: "/under-construction",
      name: "underConstruction",
      component: UnderConstruction
    }, {
      path: "/settings/services/menu-board",
      name: "settingsMenuBoard",
      component: SettingsMenuBoard
    }, {
      path: "/settings/services/mobile-app",
      name: "settingsMobileApp",
      component: SettingsMobileApp
    }, {
      path: "/settings/qr-payment",
      name: "SettingsQRPayment",
      component: SettingsQRPayment
    }, {
      path: "/settings/external-pos",
      name: "settingsExternalPos",
      component: SettingsExternalPos
    }, {
      path: "/settings/tunnel",
      name: "settingsTunnel",
      component: SettingsTunnel
    }, {
      path: "/external_pos_synchronisation",
      name: "externalPosSynchronisation",
      component: ExternalPosSynchronisation
    }, {
      path: "/check-external-pos-connection",
      name: "checkExternalPos",
      component: CheckExternalConnection
    }, {
      path: "/settings/shipper",
      name: "settingsShipper",
      component: SettingsShipper
    }, {
      path: "/settings/uber-eats",
      name: "UberEats",
      component: UberEats
    }, {
      path: "/settings/maitred-sync",
      name: "MaitreDSync",
      component: MaitreDSync
    }, {
      path: "/settings/emails",
      name: "SettingsEmail",
      component: SettingsEmail
    }, {
      path: "/branch-statistics",
      name: "branch-statistics",
      component: StatisticsBranch
    }, {
      path: "/company-statistics",
      name: "company-statistics",
      component: StatisticsCompany,
      props: {period: 'all'}
    }, {
      path: "/report/sale",
      name: "saleReport",
      component: SaleReport
    }, {
      path: "/report/inventory-out-of-stock",
      name: "inventoryOutOfStockReport",
      component: InventoryOutOfStockReport
    }, {
      path: "/style/online-ordering",
      name: "onlineOrderingStyle",
      component: OnlineOrderingStyle
    }, {
      path: "/style/kiosk",
      name: "kioskStyle",
      component: KioskStyle
    }, {
      path: "/sales",
      name: "sales",
      component: Sales
    }, {
      path: "/sales/table",
      name: "tableSales",
      component: TableSales
    }, {
      path: "/pos-sales",
      name: "posSales",
      component: POSSales
    }, {
      path: "/pos-sales/:id",
      name: "posSale",
      component: POSSale
    }, {
      path: "/pos-invoices",
      name: "posInvoices",
      component: POSInvoices
    }, {
      path: "/pos-invoices/:id",
      name: "posInvoice",
      component: POSInvoice
    }, {
      path: "/tip-management",
      name: "tipManagement",
      component: TipManagement
    }, {
      path: "/cash-drawer-management",
      name: "cashDrawerManagement",
      component: CashDrawerManagement
    }, {
      path: "/price-adjustments",
      name: "priceAdjustments",
      component: PriceAdjustments
    }, {
      path: "/refunds",
      name: "refunds",
      component: Refunds
    }, {
      path: "/voids",
      name: "voids",
      component: Voids
    }, {
      path: "/catering-deliveries",
      name: "cateringDeliveries",
      component: CateringDeliveries
    }, {
      path: "/catering-sales",
      name: "cateringSales",
      component: CateringSales
    }, {
      path: "/catering-prep",
      name: "cateringPrep",
      component: CateringPrep
    }, {
      path: "/sale",
      name: "sale",
      component: Sale
    }, {
      path: "/customers",
      name: "customers",
      component: Customers
    }, {
      path: "/customer",
      name: "customer",
      component: Customer
    }, {
      path: "/qr-payment-requests",
      name: "qrPaymentRequests",
      component: QrPaymentRequests
    }, {
      path: "/qr-payment-request",
      name: "qrPaymentRequest",
      component: QrPaymentRequest
    }, {
      path: "/report/customer",
      name: "customerReport",
      component: CustomerReport
    }, {
      path: "/gift-cards",
      name: "giftCards",
      component: GiftCards
    }, {
      path: "/gift-card",
      name: "giftCard",
      component: GiftCard
    }, {
      path: "/gift-card-reports",
      name: "giftCardReports",
      component: GiftCardReports
    }, {
      path: "/clone-inventory",
      name: "cloneInventory",
      component: CloneInventory
    }, {
      path: "/move-company",
      name: "moveCompany",
      component: MoveCompany
    }, {
      path: "/loyalty-config",
      name: "loyaltyConfig",
      component: LoyaltyConfig
    }, {
      path: "/inventory",
      name: "inventory",
      component: Inventory
    }, {
      path: "/order-requirements",
      name: "orderRequirements",
      component: OrderRequirements
    }, {
      path: "/upsell",
      name: "upsell",
      component: Upsell
  }, {
      path: "/loyalty-transactions",
      name: "loyaltyTransactions",
      component: LoyaltyTransactions
    }, {
      path: "/loyalty-transaction",
      name: "transaction",
      component: LoyaltyTransaction
    }, {
      path: "/loyalty-accounts",
      name: "loyaltyAccounts",
      component: LoyaltyAccounts
    }, {
      path: "/loyalty-account",
      name: "loyaltyAccount",
      component: LoyaltyAccount
    }, {
      path: "/loyalty-transaction-stat",
      name: "LoyaltyTransactionStat",
      component: LoyaltyTransactionStat
    }, {
      path: "/tax",
      name: "Tax",
      component: Tax
    }, {
      path: "/taxes",
      name: "Taxes",
      component: Taxes
    }, {
      path: "/tax-group",
      name: "TaxGroup",
      component: TaxGroup
    }, {
      path: "/tax-groups",
      name: "TaxGroups",
      component: TaxGroups
    }, {
      path: "/taxes-hub",
      name: "taxesHub",
      component: TaxesHub
    }, {
      path: "/admin-commands",
      name: "AdminCommands",
      component: AdminCommands
    }, {
      path: "/app-versions",
      name: "AppVersion",
      component: AppVersion
    }, {
      path: "/server-status",
      name: "ServerStatus",
      component: ServerStatus
    }, {
      path: "/inventory-power-user",
      name: "InventoryPowerUser",
      component: InventoryPowerUser
    }, {
      path: "/heartbeat",
      name: "Heartbeat",
      component: Heartbeat
    }, {
      path: "/tunnel-migration",
      name: "TunnelMigration",
      component: TunnelMigration
    }, {
      path: "/monitoring-tools-hub",
      name: "monitoringToolsHub",
      component: MonitoringToolsHub
    }, {
      path: "/newsletter",
      name: "Newsletter",
      component: Newsletter
    }, {
      path: "/pos",
      name: "POS",
      component: POS
    }, {
      path: "/pos/kds",
      name: "KDS",
      component: POSKitchenDisplaySystem
    }, {
      path: "/dispatch-customers",
      name: "DispatchCustomers",
      component: DispatchCustomers
    },
    {
      path: "/dispatch-customer",
      name: "DispatchCustomer",
      component: DispatchCustomer
    },
    {
      path: "/translations",
      name: "Translations",
      component: Translations
    }, {
      path: "/third-party-delivery",
      name: "ThirdPartyDelivery",
      component: ThirdPartyDelivery
    }, {
      path: "/quick-config",
      name: "QuickConfig",
      component: QuickConfig
    }, {
      path: "/company-change-log",
      name: "CompanyChangeLog",
      component: CompanyChangeLog
    }, {
      path: "/reception",
      name: "Reception",
      component: Reception
    }, {
      path: "/role-permissions",
      name: "RolePermissions",
      component: RolePermissions
    }, {
      path: "/branch-payment",
      name: "BranchPayment",
      component: BranchPayment
    }, {
      path: "/file-import",
      name: "FileImport",
      component: FileImport
    }, {
      path: "/company/paid-features",
      name: "PaidFeatures",
      component: PaidFeatures
    }, {
      path: "/sms-report",
      name: "SmsReport",
      component: SmsReport
    }, {
      path: "/anomaly-reports",
      name: "AnomalyReports",
      component: AnomalyReports
    }, {
      path: "/stats-payment",
      name: "StatsPayment",
      component: StatsPayment
    }, {
      path: "/pos/order-options",
      name: "PosOrderOptions",
      component: OrderOptions
    }, {
      path: "/training",
      name: "Training",
      component: Training
    }, {
      path: "/create-test-sale",
      name: "CreateTestSale",
      component: CreateTestSale
    }, {
      path: "/media-manager",
      name: "MediaManager",
      component: MediaManager
    }, {
      path: "/aims-tickets",
      name: "aimsTickets",
      component: AimsTickets
    }, {
      path: "/aims-ticket/new",
      name: "aimsTicketNew",
      component: AimsTicketEdit
    }, {
      path: "/aims-ticket/edit",
      name: "aimsTicketEdit",
      component: AimsTicketEdit
    }, {
      path: "/custom-report-qr",
      name: "customReportQrCodeSales",
      component: CustomReportQrCodeSales
    }, {
      path: "/api-keys",
      name: "apiKeys",
      component: ApiKeys
    }, {
      path: "/qsr",
      name: "componentTestQSR",
      component: ComponentTestQSR
    }, {
      path: "/licenses",
      name: "licenses",
      component: Licenses
    }, {
      path: "/slide-settings",
      name: "slideSettings",
      component: SlideSettings
    }, {
      path: "/receipt-configuration",
      name: "receiptConfiguration",
      component: ReceiptConfiguration
    }, {
      path: "/printer-groups",
      name: "printerGroups",
      component: PrinterGroups
    }, {
      path: "/printer-group/new",
      name: "printerGroupNew",
      component: PrinterGroupEdit
    }, {
      path: "/printer-group/edit",
      name: "printerGroupEdit",
      component: PrinterGroupEdit
    }, {
      path: "/printers",
      name: "Printers",
      component: Printers
    }, {
      path: "/report/punch",
      name: "PunchReport",
      component: PunchReport
    }, {
      path: "/employee/edit",
      name: "employeeEdit",
      component: EmployeeEdit
    }, {
      path: "/employee/new",
      name: "employeeNew",
      component: EmployeeEdit
    }, {
      path: "/employees",
      name: "employees",
      component: Employees
    }, {
      path: "/roles",
      name: "posRoles",
      component: Roles
    }, {
      path: "/role/edit",
      name: "posRoleEdit",
      component: RoleEdit
    }, {
      path: "/role/new",
      name: "posRoleNew",
      component: RoleEdit
    }, {
      path: "/revenue-centers",
      name: "revenueCenters",
      component: RevenueCenters
    }, {
      path: "/revenue-center/edit",
      name: "revenueCenterEdit",
      component: RevenueCenterEdit
    }, {
      path: "/revenue-center/new",
      name: "revenueCenterNew",
      component: RevenueCenterEdit
    }, {
      path: "/low-level-hub",
      name: "lowLevelHub",
      component: LowLevelHub
    }, {
      path: "/global-support-debug-hub",
      name: "globalSupportDebugHub",
      component: GlobalSupportDebugHub
    }, {
      path: "/global-reports-hub",
      name: "globalReportsHub",
      component: GlobalReportsHub
    }, {
      path: "/organization-hub",
      name: "branchSuperAdminHub",
      component: BranchSuperAdminHub
    }, {
      path: "/branch/global-settings-hub",
      name: "branchGlobalSettingsHub",
      component: BranchGlobalSettingsHub
    }, {
      path: "/visual-config-hub",
      name: "visualConfigurationsHub",
      component: VisualConfigurationsHub
    }, {
      path: "/sales-hub",
      name: "saleHub",
      component: SaleHub
    }, {
      path: "/branch-customers-hub",
      name: "branchCustomersHub",
      component: BranchCustomersHub
    }, {
      path: "/loyalty-hub",
      name: "loyaltyHub",
      component: LoyaltyHub
    }, {
      path: "/catering-hub",
      name: "cateringHub",
      component: CateringHub
    }, {
      path: "/company-hub",
      name: "companySuperAdminHub",
      component: CompanySuperAdminHub
    }, {
      path: "/external-pos-hub",
      name: "externalPosHub",
      component: ExternalPosHub
    }, {
      path: "/company/global-settings-hub",
      name: "companyGlobalSettingsHub",
      component: CompanyGlobalSettingsHub
    }, {
      path: "/company/support-hub",
      name: "companySupportHub",
      component: CompanySupportHub
    }, {
      path: "/pos-configuration-hub",
      name: "posConfigurationHub",
      component: PosConfigurationHub
    }, {
      path: "/pos-printer-hub",
      name: "posPrinterHub",
      component: PosPrinterHub
    }, {
      path: "/marketing-hub",
      name: "marketingHub",
      component: MarketingHub
    }, {
      path: "/promotion-hub",
      name: "promotionHub",
      component: PromotionHub
    }, {
      path: "/kiosk-hub",
      name: "kioskHub",
      component: KioskHub
    }, {
      path: "/help-support-hub",
      name: "helpSupportHub",
      component: HelpSupportHub
    }, {
      path: "/pos-help-support-hub",
      name: "posHelpSupportHub",
      component: PosHelpSupportHub
    }, {
      path: "/release-notes",
      name: "releaseNotes",
      component: ReleaseNotes
    }, {
      path: "/settings/timesheet",
      name: "SettingsTimesheet",
      component: SettingsTimesheet
    }, {
      path: "/branch-scheduled-shutdown",
      name: "ScheduledShutdown",
      component: ScheduledShutdown
    }, {
      path: "/pos/visual-config",
      name: "PosVisualConfig",
      component: VisualConfig
    }, {
      path: "/batch-reading",
      name: "BatchReadings",
      component: BatchReadings
    }, {
      path: "/batch-reading/:id",
      name: "BatchReading",
      component: BatchReading
    }, {
      path: "/staging",
      name: "StagingDashboard",
      component: StagingDashboard
    }, {
      path: "/pos/mev-config",
      name: "MevConfig",
      component: MevConfig
    }
  ]
});
